<template>
  <div
    class="divide-static-default-mid flex flex-col space-y-8 divide-y *:py-12"
  >
    <BaseOrderlineBlock
      v-for="orderLine in order.orderLines"
      :key="orderLine.id"
    >
      <div class="body-1-bold mb-4 tabular-nums">{{ orderLine.id }}</div>

      <div class="caption">
        {{ i18n(translations.sku) }}
      </div>
      <div class="body-2 mb-8 whitespace-normal">
        {{ orderLine.sku }}
      </div>

      <div class="caption">
        {{ i18n(translations.quantity) }}
      </div>
      <div class="body-2">
        {{ orderLine.quantity }}
      </div>
    </BaseOrderlineBlock>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { Order } from '../../../../Tab.types'
import BaseOrderlineBlock from '../BaseOrderlineBlock/BaseOrderlineBlock.vue'

import translations from './OrderLinesCell.translations'

const i18n = useI18n()

defineProps<{ order: Order }>()
</script>
